import { render, staticRenderFns } from "./PcPcmTable.vue?vue&type=template&id=21fc2420&"
import script from "./PcPcmTable.vue?vue&type=script&lang=js&"
export * from "./PcPcmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports